<div class="bk-dialog bk-dialog__event">
	<button class="bk-modal__close_btn"
		(click)="close()"
		type="button">
		<mat-icon>close</mat-icon>
	</button>

	<h4 mat-dialog-title>
		<ng-container *ngIf="data && data.commodityType"
			class="bk-modal__header-title">
			{{'Edit' | translate }} {{'Commodity' | translate }}
		</ng-container>
		<ng-container *ngIf="!data || !data.commodityType"
			class="bk-modal__header-title">
			{{'Add' | translate }} {{'Commodity' | translate }}
		</ng-container>
	</h4>

	<div mat-dialog-content>
		<ranch-commodity-type-form
			[isCommodityTypeSelectionAllowed]="!data || !data.commodityType"
			[commodityTypeId]="data && data.commodityType ? data.commodityType.CommodityTypeId : null"
			[commodityTypeName]="data && data.commodityType ? data.commodityType.CommodityTypeName : null"
			[cropTypeIds]="data && data.commodityType ? data.commodityType.CropTypeIds : []"
			[selectedCommodityTypeIds]="data ? data.selectedCommodityTypeIds : []"
			[isRanchAgnostic]="true"
			(onCancel)="closeFinal()"
			(onHide)="hide()"
			(onShow)="show()"
			(formSubmit)="submit($event)">
		</ranch-commodity-type-form>
	</div>

	<div mat-dialog-actions
		align="end">
		<button mat-button
			class="bk-button bk-button--medium bk-button--text-only bk-dialog__button--secondary"
			(click)="close()">
			{{ 'Cancel' | translate }}
		</button>
		<button mat-button
			class="bk-button bk-button--medium"
			[disabled]="!commodityTypeForm || !commodityTypeForm.isFormValid"
			(click)="commodityTypeForm.submit()">
			{{ (data && data.commodityType ? 'Save' : 'Add') | translate }} {{'Commodity' | translate }}
		</button>
	</div>
</div>
